import React from 'react'
import { NotificationContainer, NotificationManager } from 'react-notifications'

export const NotificationContext = React.createContext()

const DURATION = 1500
function notificationMaker(type) {
  return function (title, text) {
    return NotificationManager[type](text, title, DURATION)
  }
}

export default function Notificacion({ children }) {
  const info = notificationMaker('info')
  const error = notificationMaker('error')
  const warning = notificationMaker('warning')
  const success = notificationMaker('success')

  const notify = {
    info,
    error,
    success,
    warning,
  }

  return (
    <NotificationContext.Provider value={{ notify }}>
      <NotificationContainer />
      {children}
    </NotificationContext.Provider>
  )
}
